export default __webpack_public_path__ + "static/TeamJohnyBridges-46876583075c8032aa83c0e52ae18062.png";